import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  Renderer2,
  AfterViewInit, Component
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'loader',
  template: `
    <div class='d-flex justify-content-center m-5 p-5'>
      <mat-spinner diameter='70'></mat-spinner>
    </div>`,
  imports: [MatProgressSpinnerModule],
  standalone: true
})
export class LoaderComponent {}

@Component({
  selector: 'no-content',
  template: `
    <div class='container'>
      <div class='row justify-content-center m-auto pt-5'>
        <img style='width: 20%' src="assets/images/no-matching-results.svg" />
        <div class="text-center">
          <p>{{ label | translate }}</p>
        </div>
      </div>
    </div>`,
  imports: [TranslateModule],
  standalone: true
})
export class NoContentComponent {
  @Input() label = 'website.customer_location.table.errors.no_results';
}

@Component({
  selector: 'no-content-card',
  template: `
    <mat-card  class='p-3 m-3'> {{ label | translate }} </mat-card>
  `,
  imports: [TranslateModule, MatCardModule],
  standalone: true
})
export class NoContentCardComponent {
  @Input() label = 'website.customer_location.table.errors.no_results';
}
export type NoContentComponentType = 'CARD' | 'STANDARD';

@Directive({
  selector: '[isLoading]'
})
export class LoadingDirective implements AfterViewInit {
  private loaderComponentRef: any;
  private noComponentRef: any;
  private contentEmbeddedViewRef: any;

  @Input()
  set isLoading({ isLoading, hasContent, customLabel, noContentComponentType  }: { isLoading: boolean, hasContent: boolean, customLabel?: string, noContentComponentType ?: NoContentComponentType}) {
    this.clearViews();

    if (isLoading) {
      this.showLoader();
    } else if (hasContent) {
      this.showContent();
    } else {
      this.showNoContent(customLabel, noContentComponentType);
    }
  }

  constructor(
    private view: ViewContainerRef,
    private template: TemplateRef<any>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.createEmbeddedView();
    this.toggleViewVisibility(this.contentEmbeddedViewRef, 'd-none');
    this.noComponentRef?.destroy();
  }

  private createEmbeddedView(): void {
    this.contentEmbeddedViewRef = this.view.createEmbeddedView(this.template);
    this.renderer.addClass(this.contentEmbeddedViewRef.rootNodes[0], 'd-block');
  }

  private showLoader(): void {
    this.toggleViewVisibility(this.contentEmbeddedViewRef, 'd-none');
    this.loaderComponentRef = this.view.createComponent(LoaderComponent);
  }

  private showNoContent(customLabel: string, noContentComponentType: NoContentComponentType= 'STANDARD' ): void {
    if (noContentComponentType === 'STANDARD'){
      this.noComponentRef = this.view.createComponent(NoContentComponent);
    }else{
      this.noComponentRef = this.view.createComponent(NoContentCardComponent);
    }
    if (customLabel){
      this.noComponentRef.instance.label = customLabel;
    }
  }

  private showContent(): void {
    this.toggleViewVisibility(this.contentEmbeddedViewRef, 'd-block');
  }

  private clearViews(): void {
    this.loaderComponentRef?.destroy();
    this.noComponentRef?.destroy();
  }

  private toggleViewVisibility(viewRef: any, className: string): void {
    if (viewRef) {
      this.renderer[className === 'd-block' ? 'removeClass' : 'addClass'](viewRef.rootNodes[0], 'd-none');
    }
  }
}
